import Vue from "vue";
import VueRouter from "vue-router";

const Login = () => import("../views/Login.vue");
const ForgotPassword = () => import("../views/ForgotPassword.vue");
const Profile = () => import("../views/Profile.vue");
const Meetings = () => import("../views/Meetings.vue");
const MeetingStart = () => import("../views/MeetingStart.vue");
const PageNotFound = () => import("../views/PageNotFound.vue");
const CorrespondenceVoteAndSign = () => import("../views/CorrespondenceVoteAndSign.vue");

Vue.use(VueRouter);

import store from "@/store/store";

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters["auth/isAuthenticated"]) {
    next();
    return;
  }
  next({ name: "meetings" });
};
const ifAuthenticated = (to, from, next) => {
  if (
    store.getters["auth/isAuthenticated"] &&
    localStorage.token &&
    localStorage.token.length > 0
  ) {
    return next();
  }
  next({ name: "login" });
};

const routes = [
  /** Home */
  {
    path: "/",
    redirect: { name: "meetings" },
    beforeEnter: ifAuthenticated,
  },
  /** Auth */
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: ifNotAuthenticated,
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
    beforeEnter: ifNotAuthenticated,
  },
  /** Profile */
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    beforeEnter: ifAuthenticated,
  },
  /** App */
  {
    path: "/meetings",
    name: "meetings",
    component: Meetings,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/meeting-start/:id",
    name: "meeting-start",
    component: MeetingStart,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/correspondence-vote-and-sign/:id",
    name: "correspondence-vote-and-sign",
    component: CorrespondenceVoteAndSign,
    beforeEnter: ifAuthenticated,
  },
  /** Page not found */
  {
    path: "*",
    name: "404",
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
